/*
 * theme.js - The main script for the theme.
 */


jQuery(function($) {



   /**
    * Handle the scroll up button.
    */


   $(window).scroll(function (event) { checkScrollUpButtonState(); });

   window.scrollToTop = function() { $('body, html').stop().animate({ scrollTop: 0 }, 800); };

   window.checkScrollUpButtonState = function() {
      var $wind = $(window);
      var $scroll = $wind.scrollTop();
      var $height = $wind.height();
      var $width = $wind.width();
      var $but = $('#scroll-top-button');
      var but_is_visible = $but.hasClass('visible');
      var can_scroll_top = $scroll > $height;

      if ($width < 2048) {
         if (!but_is_visible && can_scroll_top) $but.addClass('visible');
         if (but_is_visible && !can_scroll_top) $but.removeClass('visible');
      }
      else {
         $but.removeClass('visible');
      }
   };



   /**
    * Handle the mobile menu provided by MMenu.
    */

   $('#mobile-menu').mmenu({
      extensions 	: [ "position-top", "fullscreen", "listview-50", "fx-panels-slide-up" ],
      navbars		: {
			content : [ "prev", "search", "close" ],
			height 	: 1
		}
   },{
      offCanvas: {
         pageSelector: "#page-wrap"
      }
   });



   /**
    * Handle the login page modal.
    */

   var $recover_pass_modal = $('#RecoverPasswordModal');
   if ($recover_pass_modal.length > 0) {
      /* move to the bottom */
      $('body').append($recover_pass_modal);
      /* after submit, re-open dialog */
      if(window.location.hash == "#recover") {
         $($recover_pass_modal).modal('show');
      }
   }



   /**
    * Handle the other modals.
    */

   var $other_modals = $('#AddAddressModal,.edit-address-modal');
   if ($other_modals.length > 0) {
      $other_modals.each(function() {
         $('body').append(this);
      });
   }


   
   /**
    * Handle deleting addresses.
    */
   var $address_delete_buttons = $('.address-delete');
   if ($address_delete_buttons.length > 0) {
      $address_delete_buttons.click(function() {
         var $address_delete_button = $(this);
         var $message = $address_delete_button.data('confirm-message');
         var $form_id = $address_delete_button.data('form-id');
         Shopify.CustomerAddress.destroy($form_id, $message); return false;
      });
   }



   /**
    * Handle the product gallery.
    */
   var $gallery_main_image = $('.gallery-image-main');
   if ($gallery_main_image.length > 0 && $('body').width() > 768) {
      $gallery_main_image.elevateZoom({ zoomType: "inner" });

      $('[data-product-single-thumbnail]').click(function(thumbClickEvent) {
         var $thumb = $(this).find('img');
         var $thumb_zoom_url = $thumb.data('zoom-image');
         var $thumb_regular_url = $thumb.data('gallery-image');
         
         console.log($thumb_zoom_url);

         $gallery_main_image.prop('src', $thumb_regular_url);
         $gallery_main_image.prop('data-zoom-image', $thumb_zoom_url);
         $('.zoomWindow').css('background-image', 'url(' + $thumb_zoom_url + ')');
         thumbClickEvent.preventDefault();
         return false;
      });
   }

   

   window.shopifyAdminBar = $('#admin_bar_iframe');

   if (shopifyAdminBar.length > 0) {

      window.adjustForAdminBar = function() {
         var isSmall = (shopifyAdminBar.css('width') == '40px');
         var body = $('body');
         var bodyHasMini = body.hasClass('shopify-admin-mini');
         if (isSmall && !bodyHasMini) { body.addClass('shopify-admin-mini'); }
         if (!isSmall && bodyHasMini) { body.removeClass('shopify-admin-mini'); }
      }

      setInterval(window.adjustForAdminBar, 1000);
      window.adjustForAdminBar();
   }
   

   
});